import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

const VariantItem = ({ variant, isSelected, onClick }) => {
  const { sku_seller, options, isMapped } = variant;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const variantId = `variant-${variant._id || Math.random().toString(36).substr(2, 9)}`;

  return (
    <>
      <div
        id={variantId}
        className={`variant-item ${isMapped ? 'mapped' : ''} ${isSelected ? 'selected' : ''}`}
        onClick={onClick}
      >
        <div className="variant-info">
          <div className="variant-sku">
            <span>SKU:</span> <span>{sku_seller}</span>
          </div>
          <div className="variant-details">
            {options.map((option, index) => (
              <span key={index}>{option.name || option.slug} {index < options.length - 1 ? ' / ' : ''}</span>
            ))}
          </div>
        </div>
        {isMapped && (
          <span className="mapped-badge">Mapped</span>
        )}
      </div>
      
      <Tooltip
        placement="top"
        isOpen={tooltipOpen}
        target={variantId}
        toggle={toggleTooltip}
      >
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>SKU: {sku_seller}</div>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Options: </div>
          <div>
            {options.map((option, index) => (
              <div key={index}>
                {option.name || option.slug}
              </div>
            ))}
          </div>
        </div>
      </Tooltip>
    </>
  );
};

export default VariantItem;
